import { defaultExportListFilters } from "@/domain/export/filterExportJobs";
import { useExportJobs } from "@/features/exports/hooks/useExportJobs";
import { RecentExportsTable } from "@/features/exports/components/RecentExportsTable";

export function RecentExportsSection({ embedded }: { embedded?: boolean }) {
  const { data, isLoading, error } = useExportJobs(0, 5, defaultExportListFilters());

  if (isLoading) {
    return (
      <p className={`text-sm text-[var(--muted)] ${embedded ? "px-4 py-6" : ""}`}>
        Loading exports…
      </p>
    );
  }
  if (error) return <RecentExportsTable items={[]} />;

  return <RecentExportsTable items={data?.items ?? []} />;
}
